import React from 'react';
import './StatusWrapper.css';

function StatusWrapper({ children }: React.PropsWithChildren<object>): React.ReactNode {
  return <div className="status-wrapper">{children}</div>;
}

export default StatusWrapper;
